<div class="select-dropdown" [ngClass]="{ 'btn-no-border': pillBtn }">
  <label *ngIf="label.length > 0 && !searchSelect" class="align-dropdown-label" title="{{ label }}" [ngClass]="{ 'small-labels': smallSelect }"
    >{{ label }}<span *ngIf="required" class="color-red" title="Required"> *</span></label
  >
  <div class="dropdown" #selectDropdown>
    <a
      #toggleButton
      *ngIf="!searchSelect"
      class="dropdown-toggle btn-sm default-font"
      [ngClass]="{
        invalid: (!selected['label'] && required && changed) || invalid,
        valid: selected['label'] && changed,
        'small-labels-selected': smallSelect,
        'no-wrap': smallSelect,
        'th-btn-pill': pillBtn,
        active: pillBtn && selected['label'],
      }"
      role="button"
      id="{{ id }}"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      tabindex="{{ tab }}"
      [class.disabled]="disabled ? true : null"
      (click)="toggleMenu($event)"
    >
      <span class="selected-value" title="{{ selected['label'] ? selected['label'] : placeholder }}">{{
        selected['label'] ? selected['label'] : placeholder
      }}</span>
    </a>
    <input
      *ngIf="searchSelect && !disabled"
      type="text"
      [id]="id"
      title="{{ selected['label'] ? selected['label'] : placeholder }}"
      [formControl]="control"
      class="input-font form-control search-input"
      placeholder="{{ selected['label'] ? selected['label'] : placeholder }}"
      (keydown.enter)="selectFirstOption()"
    />
    <div class="clear-button" title="Clear Search" *ngIf="control.value?.length > 0" (click)="clearSearch()">
      <i class="fa-solid fa-xmark"></i>
    </div>
    <a
      #selectMenu
      *ngIf="searchSelect"
      class="btn dropdown-toggle btn-sm default-font"
      [ngClass]="{
        invalid: (!selected['label'] && required && changed) || invalid,
        valid: selected['label'] && required && changed,
        'small-labels-selected': smallSelect,
      }"
      role="button"
      id="{{ id }}"
      aria-haspopup="true"
      aria-expanded="false"
      tabindex="{{ tab }}"
      [class.disabled]="disabled ? true : null"
      (click)="toggleMenu($event)"
    >
      <span class="selected-value input-holder"></span>
    </a>
    <div #selectMenuDiv id="{{ id }}Menu" class="dropdown-menu" attr.aria-labelledby="{{ id }}" [ngClass]="{ 'fit-width': fitWidth }">
      <span *ngIf="!noblank"
        ><a class="dropdown-item default-pointer" [ngClass]="{ 'small-labels': smallSelect }" (click)="selectOption({})" id="none" title="none"></a
      ></span>
      <div *ngIf="noblank && placeholder.length > 0 && !searchSelect" class="placeholder">
        <a
          class="dropdown-item placeholder"
          (click)="selectOption({})"
          id="none"
          title="{{ placeholder }}"
          [ngClass]="{ 'small-labels': smallSelect }"
          >{{ placeholder }}</a
        >
      </div>
      <span *ngFor="let option of options; index as i">
        <a
          class="dropdown-item default-pointer"
          [ngClass]="{
            'active-selection': selected['label'] === option?.label,
            'small-labels': smallSelect,
            disabled: option?.disabled ? option.disabled : checkDisabled(option?.value),
            'no-wrap': !fitWidth,
          }"
          (click)="selectOption(option)"
          title="{{ option?.label }}"
          id="{{ option?.value }}"
          >{{ option?.label }}<span *ngIf="option?.note" class="ml-1">{{ option?.note }}</span></a
        >
      </span>
      <span *ngIf="searchSelect && control.value?.length > 0 && options.length === 0">
        <div class="no-results">No results found</div>
      </span>
    </div>
  </div>
</div>
